<div class="access-container">
    <mat-form-field appearance="outline" class="text-primary border-primary select-primary">
        <mat-select [(ngModel)]="accessSelect">
            <mat-option value="" disabled>Add {{label}}</mat-option>
            <mat-option (click)="addIndex(idx)" *ngFor="let idx of allIndices" [value]="idx">{{idx.name}}</mat-option>
        </mat-select>
    </mat-form-field>

    <button
            type="button"
            mat-stroked-button
            class="rounded-pill pill-btn"
            *ngFor="let idx of indices"
            (click)="removeIndex(idx)"
    >
        {{idx.name}} <mat-icon>close</mat-icon>
    </button>
</div>
